import { formatColor } from '@meitu/saas-colors';
import { trackConfig, type IFramework } from '@/framework';
import { LayerType, VectorType, type ILayerProps, type ILinearGradient, type IVectorLayerProps } from '@/version-types';
import { pushHistory, requestVectorSVGPreview, updateLayer } from '../utils';

export interface IFillColor {
    /**
     * 设置矢量图层填充色
     *
     * @param layerID - 图层 ID
     * @param color - 填充色
     * @param options - 配置项；`options.writeHistory` - 是否写入历史记录
     */
    setFillColor(layerID: string, color: string, options?: { writeHistory: boolean }): ILayerProps | void;
}

export class FillColor implements IFillColor {
    private prevLayer: ILayerProps | null = null;

    constructor(private framework: IFramework) {}

    setFillColor(layerID: string, color: string, options = { writeHistory: false }) {
        const prevLayer = (() => {
            if (this.prevLayer?.id === layerID) return this.prevLayer;
            this.prevLayer = this.framework.service.flatLayer.getLayer(layerID, true);
            return this.prevLayer;
        })();

        if (!prevLayer || prevLayer.layerType !== LayerType.VECTOR_LAYER) return;

        const prevLayerData = prevLayer.data as IVectorLayerProps;
        const { vectorType } = prevLayerData;

        if (vectorType === VectorType.Graph) return;

        const { writeHistory } = options;

        if (writeHistory) {
            const nextLayer = this.framework.service.flatLayer.getLayer(layerID, true);

            requestVectorSVGPreview(this.framework, 'commit', nextLayer);
            updateLayer(this.framework, nextLayer);

            pushHistory(this.framework, prevLayer, nextLayer, trackConfig[LayerType.VECTOR_LAYER].fill);
            this.prevLayer = null;

            return nextLayer;
        }

        const isGradient = color.startsWith('linear-gradient');
        const nextLayerData: IVectorLayerProps = {
            ...prevLayerData,
            fill: isGradient ? '' : color,
            fillGradient: isGradient ? (formatColor(color) as ILinearGradient) : '',
        };
        const nextLayer: ILayerProps = { ...prevLayer, data: nextLayerData };

        requestVectorSVGPreview(this.framework, 'update', nextLayer);
        updateLayer(this.framework, nextLayer, { dataOnly: true });

        return nextLayer;
    }
}
